export default __webpack_public_path__ + "static/media/img2.58bd1218.PNG";